import { App } from '@capacitor/app';
import {
  IonButton,
  IonButtons,
  IonCard,
  IonCardContent,
  IonContent,
  IonIcon,
  IonImg,
  IonItem,
  IonLabel,
  IonList,
  IonPage,
  IonText,
  isPlatform,
} from '@ionic/react';
import {
  chevronForwardOutline,
} from 'ionicons/icons';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { ClientTaxonomyEvents } from '@/interfaces/AnalyticsInterface/AnalyticsInterface';
import { saveVersionControl } from '@/redux/configOptions/config';
import { clearEcommercePlatformData } from '@/redux/ecommerceWidget/ecommerceWidget';
import { existingCartId } from '@/redux/invoiceManaged/cartIdManaged';
import { saveMerchantData } from '@/redux/merchant/merchant';
import { Analytics } from '@/services/analytics';
import { RootState } from '@/store';

import ArrowIcon from '../../../../assets/icons/menu-selector-arrow-right-red.svg';
import PhoneIcon from '../../../../assets/icons/phone.svg';
import FaqIcon from '../../../../assets/imgs/faq-icon.svg';
import InterPhoneIcon from '../../../../assets/imgs/interphone-icon.svg';
import ProfileDefault from '../../../../assets/imgs/profile-default.webp';
import SettingIcon from '../../../../assets/imgs/settings-icon.svg';
import LogoutModal from '../../../../components/auth/LogoutModal';
import Button from '../../../../components/common/Button';
import { ROUTES_PATH } from '../../../../constants';
import useModal from '../../../../hooks/useModal';
import { MenuItem } from '../../../../interfaces/ProfileInterface/ProfileInterface';
import { checkmanagedOffers, checkpreferredOfferAndNoPreferredOffer, checkValueShowSelect, existingCommercialOffers, existingEcoOffers } from '../../../../redux/commercialOffers/commercialOffers';
import { clearFiltersSaved, saveCartId, saveNameOrDni } from '../../../../redux/filters/filters';
import { getMerchants } from '../../../../redux/operation/operationsAPI';
import { CommercialAgent, Merchant } from '../../../../redux/operation/operationsInterface';
import { clearMonthSummaries, saveSettlements } from '../../../../redux/reporting/reporting';
import TokenService from '../../../../services/token';
import styles from './ProfileMobile.module.scss';
import { clearIsPreferredOffer } from '@/redux/orderManaged/orderManaged';

export default function ProfileMobile() {
  const dispatch = useDispatch();
  const [username, setUsername] = useState<string | null>();
  const merchantInfo = useSelector((state: RootState) => state.merchantData.data);

  const history = useHistory();
  const [commercialAgent, setCommercialAgent] = useState<CommercialAgent>();
  // objeto por defecto de comercial agent
  const defaultCommercialAgent: CommercialAgent = {
    name: 'Pepper',
    surname: 'Group',
    phones: ['91 216 12 12'],
    email: 'consultascomercial@peppergroup.es',
    call_center_phone: '91 216 12 12',
  };

  const menu: MenuItem[] = [
    {
      name: 'Configuración',
      icon: chevronForwardOutline,
      item: SettingIcon,
      redirectPath: ROUTES_PATH.CONFIGURATION,
    },
    {
      name: 'Contacto',
      icon: chevronForwardOutline,
      item: InterPhoneIcon,
      redirectPath: ROUTES_PATH.CONTACT,
    },
    {
      name: 'Ayuda',
      icon: chevronForwardOutline,
      item: FaqIcon,
      redirectPath: ROUTES_PATH.HELP,
    },
  ];

  const [merchantData, setmerchantData] = useState<Merchant>();
  const [appVersion, setAppVersion] = useState('');

  if (!isPlatform('mobileweb') && !isPlatform('desktop')) {
    App?.getInfo().then((version) => {
      setAppVersion(version.version);
    });
  }

  const { presentModal: presentLogoutModal } = useModal(LogoutModal);

  const handleCloseSession = () => {
    const { LOGIN } = ROUTES_PATH;
    TokenService.clearSession();
    Analytics.registerAnalyticsEvent({ [ClientTaxonomyEvents.LOGOUT]: {} });
    dispatch(saveSettlements([]));
    dispatch(clearMonthSummaries());
    dispatch(saveNameOrDni(''));
    dispatch(saveCartId(''));
    dispatch(clearFiltersSaved());
    dispatch(saveMerchantData(null));
    history.push(ROUTES_PATH.LOGIN);
    dispatch(existingCommercialOffers(false));
    dispatch(checkmanagedOffers(false));
    dispatch(checkpreferredOfferAndNoPreferredOffer(false));
    dispatch(checkValueShowSelect(false));
    dispatch(clearIsPreferredOffer());
    dispatch(existingEcoOffers(false));
    dispatch(existingCartId(false));
    dispatch(clearEcommercePlatformData());
    localStorage.setItem('autoBiometry', 'false');
    history.push(LOGIN);
    dispatch(saveVersionControl(undefined));
    sessionStorage.removeItem("Pepper-AlertDismissed");
  };

  const merchantAndCommercialApiCall = async () => {
    try {
      let merchantResponse: Merchant;
      if (merchantInfo) {
        merchantResponse = merchantInfo;
      } else {
        merchantResponse = await getMerchants();
        dispatch(saveMerchantData(merchantResponse));
      }
      setmerchantData(merchantResponse);
      const commercialAgentData: CommercialAgent = getCommercialAgent(merchantResponse);
      setCommercialAgent(commercialAgentData);
    } catch (err) {
      console.log(err);
    }
  };
  const getCommercialAgent = (data: any): CommercialAgent => {
    if (!data || !data.commercial_agent) {
      return defaultCommercialAgent;
    }

    const commercialAgentData = data.commercial_agent;

    return {
      name: commercialAgentData.name || defaultCommercialAgent.name,
      surname: commercialAgentData.surname || defaultCommercialAgent.surname,
      phones: commercialAgentData.phones.length > 0 ? commercialAgentData.phones : defaultCommercialAgent.phones,
      email: commercialAgentData.email || defaultCommercialAgent.email,
      call_center_phone: commercialAgentData.call_center_phone || defaultCommercialAgent.call_center_phone,
    };
  };
  const handleCall = () => {
    Analytics.registerAnalyticsEvent({ [ClientTaxonomyEvents.CONTACT]: { type: 'PHONE' } });
    window.open(`tel:${commercialAgent?.phones[0]}`);
  };
  useEffect(() => {
    merchantAndCommercialApiCall();
  }, []);

  useEffect(() => {
    setUsername(localStorage.getItem('username'));
  }, [username]);

  function handleLogout() {
    presentLogoutModal({
      onDismiss: (doLogout) => {
        if (doLogout) {
          handleCloseSession();
        }
      },
    });
  }

  return (
    <IonPage className={styles.profilePageWrapperMobile}>
      <IonContent>
        <div className={styles.mobileHeader}>
          <div className={styles.headerTitle}>
            <IonText className={styles.titleText}>
              Perfil
            </IonText>
          </div>
        </div>
        <div className={styles.pageProfileMobile}>
          <div className={styles.profileMobileContent}>
            <div className={styles.profileMobileHeader}>
              <div className={styles.profileMobileHeaderContent}>
                <IonImg src={ProfileDefault} className={styles.profileMobileBannerImg} />
                <IonText className={styles.profileMobileBannerText}>
                  {merchantData?.commercial_name}
                </IonText>
                <IonText className={styles.profileMobileBannerUser}>{username}</IonText>
              </div>
              <IonCard className={styles.cardMobile}>
                <IonCardContent className={styles.cardMobileContent}>
                  <div className={styles.profileMobileCardContent}>
                    <div className={styles.profileMobileCardContentInfo}>
                      <div className={styles.profileMobileCardContentWrapper}>

                        <div className={styles.profileMobileCardContentInfoDiv}>
                          <IonText className={styles.profileMobileCardDivText}>
                            Tu comercial Pepper
                          </IonText>
                          <IonLabel className={styles.profileMobileCardDivUser}>
                            {commercialAgent?.name}
                            {' '}
                            {commercialAgent?.surname}
                          </IonLabel>
                        </div>
                      </div>
                      <div className={styles.profileMobileCardContentInfoButton}>
                        <IonButtons className={styles.profileMobileCardButton}>

                          <IonButton
                            onClick={() => {
                              handleCall();
                            }}
                          >
                            <div>
                              <IonIcon src={PhoneIcon} className={styles.callIcon} />
                              <IonLabel className={styles.callIconText}>Llamar</IonLabel>
                            </div>
                          </IonButton>
                        </IonButtons>
                      </div>
                    </div>
                    <div className={styles.profileMobileCardContentData}>
                      <IonText className={styles.profileMobileCardContentDataPhone}>
                        {commercialAgent?.phones[0]}
                      </IonText>
                      <IonText className={styles.profileMobileCardContentDataPoint}>
                        ·
                      </IonText>
                      <IonText className={styles.profileMobileCardContentDataEmail}>
                        {commercialAgent?.email}
                      </IonText>
                    </div>
                  </div>
                </IonCardContent>
              </IonCard>
            </div>
            <div className={styles.profileMobileList}>
              <IonList>
                {menu.map(({
                  name, icon, item, redirectPath,
                }: MenuItem) => (
                  <IonItem
                    key={name}
                    className={styles.listItems}
                    onClick={() => {
                      if (redirectPath) {
                        history.push(redirectPath);
                      }
                    }}
                  >
                    <div className={styles.listInfo}>
                      <IonImg src={item} />
                      <IonLabel className={styles.listInfoName}>{name}</IonLabel>
                    </div>
                    <div className={styles.listArrow}>
                      <IonIcon
                        src={ArrowIcon}
                        icon={icon}
                        slot="start"
                        className={styles.listArrowIcon}
                      />
                    </div>
                  </IonItem>
                ))}
                {' '}
                {appVersion && <p className={styles.versionData}>{`v${appVersion}`}</p>}
              </IonList>

              <Button
                className={styles.buttonProfileLogout}
                fill="outline"
                id="button-profile-logout mobile-button"
                onClick={() => handleLogout()}
              >
                <IonLabel>Cerrar sesión</IonLabel>
              </Button>
            </div>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
}
